export const apiURL = 'https://admin.vzpurposecoin.com'
// export const apiURL = 'http://localhost:3000' 
// export const apiURL = 'http://verizoncoin-env-4.us-east-1.elasticbeanstalk.com'
